import React, { Component } from 'react';
import AddressDetails from './AddressDetails';
import InputButton from '../../../../../../components/ZUILib/InputButton';

export default class CheckboxData extends Component {
  constructor(props) {
    super(props);
    this.addresses = [];
    this.addressDetails = [];
    this.delieveryDaysInfo = [];
    this.deliveryDayAndAddressInfo = this.props.deliveryDayAndAddressInfo;
    this.getUpdatedData = this.getUpdatedData.bind(this);
    this.addChildControlRef = this.addChildControlRef.bind(this);
  }

  addChildControlRef(childControl) {
    /* eslint-disble */
    if (childControl === null) {
      return;
    }
    let exist = false;
    this.addressDetails.map((child) => {
      if (child.props.id === childControl.props.id) {
        exist = true;
        return exist;
      }
      return false;
    });
    if (this.addressDetails.length < 1 || !exist) {
      this.addressDetails.push(childControl);
    }
  }
  getUpdatedData() {
    this.addressDetails.forEach((address, index) => {
      this.deliveryDayAndAddressInfo[index].delieveryDaysInfo = address.getOptedDays();
    });

    return this.deliveryDayAndAddressInfo;
  }
  render() {
    const cancelButton = {
      name: 'Cancelar',
      type: 'button',
      value: 'Cancelar',
      id: 'cancelButton',
      style: 'btnSecondaryAction',
      onClickHandler: this.props._handleCancelTemproryAddressPreferenceChanges,

    };
    const submitButton = {
      type: 'button',
      value: 'Guardar',
      style: 'btnPrimaryAction',
      id: 'submitButton',
      onClickHandler: this.props.handleSumbitChangedAddressPreference,
    };
    const eventStatusForSuspended = this.props.eventStatusForSuspended;

    const deliveryDayAndAddressInfo = this.props.deliveryDayAndAddressInfo ? this.props.deliveryDayAndAddressInfo : [];

    return (
      deliveryDayAndAddressInfo.length > 0 ?
        <div className="giftPAAddress" style={{ display: 'block' }}>
          <div className="row">
            {deliveryDayAndAddressInfo.map((address, index) => (
              <AddressDetails
                key={'pfa' + index}
                id={'pfa' + index}
                changeAddressDeliveryPreference={this.props.changeAddressDeliveryPreference}
                address={address} {...this.props}
                ref={(addressDetail) => { this.addChildControlRef(addressDetail); }}
                eventStatusForSuspended={eventStatusForSuspended}
              />
            ))
            }
          </div>
          <div className="row">
            <div className="col-sm-6 giftPAButtons">
              {/* below condition for suspended/Closed event status */}
              {eventStatusForSuspended === true ? null : <InputButton buttonAttr={cancelButton} /> }
              {eventStatusForSuspended === true ? null : <InputButton buttonAttr={submitButton} /> }
            </div>
          </div>
        </div> : null
    );
  }
}
